/* Host Mode: version switch, picker, ladder, timer, tally. No dependencies. */
(function () {
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function press(btns, on) { btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b === on)); }); }

  /* ---- Version: Regular / Adult / Family / Workout ---- */
  function applyVersion(v) {
    all('[data-hm-var]').forEach(function (li) {
      var ver = li.getAttribute('data-hm-var');
      li.hidden = !(ver === 'regular' || ver === v);
    });
    all('[data-hm-version]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hm-version') === v)); });
  }
  function initVersions() {
    var current = store('hm_version') || 'regular';
    if (current === 'adult' && store('hm_adult_ok') !== '1') current = 'regular';
    applyVersion(current);
    all('[data-hm-versions]').forEach(function (box) {
      var gate = box.querySelector('[data-hm-gate]');
      all('[data-hm-version]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-hm-version');
          if (v === 'adult' && store('hm_adult_ok') !== '1') { if (gate) gate.hidden = false; return; }
          if (gate) gate.hidden = true;
          store('hm_version', v); applyVersion(v);
        });
      });
      var ok = box.querySelector('[data-hm-gate-ok]');
      if (ok) ok.addEventListener('click', function () { store('hm_adult_ok', '1'); store('hm_version', 'adult'); gate.hidden = true; applyVersion('adult'); });
    });
  }

  /* ---- Picker on the hub ---- */
  function initPicker() {
    var box = document.querySelector('[data-hm-picker]'); if (!box) return;
    var players = 2, game = 'any', last = null;
    var cards = all('[data-hm-card]'), dealt = box.querySelector('[data-hm-dealt]'), none = document.querySelector('[data-hm-none]');
    var pBtns = all('[data-hm-players]', box), gBtns = all('[data-hm-game]', box);
    function fits(c) {
      var min = +c.getAttribute('data-min'), max = +c.getAttribute('data-max');
      var okP = players >= 6 ? max >= 6 : (players >= min && players <= max);
      var okG = game === 'any' || (' ' + c.getAttribute('data-games') + ' ').indexOf(' ' + game + ' ') > -1;
      return okP && okG;
    }
    function filter() {
      var n = 0;
      cards.forEach(function (c) { var ok = fits(c); c.hidden = !ok; c.classList.remove('is-dealt'); if (ok) n++; });
      if (none) none.hidden = n > 0;
      return n;
    }
    pBtns.forEach(function (b) { b.addEventListener('click', function () { players = +b.getAttribute('data-hm-players'); press(pBtns, b); filter(); }); });
    gBtns.forEach(function (b) { b.addEventListener('click', function () { game = b.getAttribute('data-hm-game'); press(gBtns, b); filter(); }); });
    box.querySelector('[data-hm-deal]').addEventListener('click', function () {
      filter();
      var pool = cards.filter(function (c) { return !c.hidden; });
      dealt.hidden = false; dealt.textContent = '';
      if (!pool.length) { dealt.textContent = 'Nothing for that combination yet. Change the players or the game.'; return; }
      var pick = pool[Math.floor(Math.random() * pool.length)];
      if (pool.length > 1) { while (pick === last) pick = pool[Math.floor(Math.random() * pool.length)]; }
      last = pick; pick.classList.add('is-dealt');
      var b = document.createElement('b'); b.textContent = pick.getAttribute('data-name');
      var s = document.createElement('span'); s.textContent = pick.getAttribute('data-summary');
      var a = document.createElement('a'); a.className = 'hm-link'; a.href = pick.getAttribute('href'); a.textContent = 'Teach me this one';
      dealt.appendChild(b); dealt.appendChild(s); dealt.appendChild(a);
    });
  }

  /* ---- Shot Ladder scoreboard: five spaces, start in the middle, off the end wins ---- */
  function initLadder(el) {
    var pos = 2, wins = [0, 0], over = false;
    var lad = el.querySelector('[data-hm-ladder]'), ver = el.querySelector('[data-hm-verdict]'), tal = el.querySelector('[data-hm-tally]');
    var hits = all('[data-hm-hit]', el), again = el.querySelector('[data-hm-again]');
    var talk = ['Still no winner.', "One more and it's over.", "They're on the edge."];
    function draw() {
      lad.textContent = '';
      for (var i = 0; i < 5; i++) { var c = document.createElement('i'); if (!over && i === pos) c.className = 'is-on'; lad.appendChild(c); }
      tal.textContent = 'You ' + wins[0] + ' · Them ' + wins[1];
      hits.forEach(function (b) { b.hidden = over; }); again.hidden = !over;
      if (!over) ver.textContent = talk[Math.abs(pos - 2)];
    }
    hits.forEach(function (b) { b.addEventListener('click', function () {
      if (over) return; pos += +b.getAttribute('data-hm-hit');
      if (pos > 4) { over = true; wins[0]++; ver.textContent = 'HOOKS! You win.'; }
      else if (pos < 0) { over = true; wins[1]++; ver.textContent = 'HOOKS! They win.'; }
      draw();
    }); });
    again.addEventListener('click', function () { pos = 2; over = false; draw(); });
    draw();
  }

  /* ---- Timer: countdown, or stopwatch when data-seconds is 0 ---- */
  function initTimer(el) {
    var total = +el.getAttribute('data-seconds'), left = total, t = null, n = 0;
    var clock = el.querySelector('[data-hm-clock]'), ver = el.querySelector('[data-hm-verdict]');
    var start = el.querySelector('[data-hm-start]'), reset = el.querySelector('[data-hm-reset]');
    var cnt = el.querySelector('[data-hm-count]'), cntN = el.querySelector('[data-hm-count-n]');
    function fmt(s) { var m = Math.floor(s / 60), r = s % 60; return m + ':' + (r < 10 ? '0' : '') + r; }
    function show() { clock.textContent = fmt(left); if (cntN) cntN.textContent = n; }
    function stop() { if (t) { clearInterval(t); t = null; } start.textContent = 'Start'; }
    start.addEventListener('click', function () {
      if (t) { stop(); if (total === 0) ver.textContent = 'Survived ' + fmt(left) + '.'; return; }
      if (total > 0 && left === 0) return;
      ver.textContent = ''; start.textContent = total === 0 ? 'Stop' : 'Pause';
      t = setInterval(function () {
        if (total === 0) { left++; show(); return; }
        left--; show();
        if (left <= 0) { stop(); ver.textContent = cnt ? 'Time. ' + n + ' landed.' : 'Time.'; }
      }, 1000);
    });
    reset.addEventListener('click', function () { stop(); left = total; n = 0; ver.textContent = ''; show(); });
    if (cnt) cnt.addEventListener('click', function () { if (t) { n++; show(); } });
    show();
  }

  /* ---- Tally ---- */
  function initTally(el) {
    var sides = all('.hm-side', el);
    sides.forEach(function (s) {
      var out = s.querySelector('[data-hm-score]'), v = 0;
      all('[data-hm-add]', s).forEach(function (b) { b.addEventListener('click', function () { v = Math.max(0, v + (+b.getAttribute('data-hm-add'))); out.textContent = v; }); });
      s._reset = function () { v = 0; out.textContent = 0; };
    });
    var r = el.querySelector('[data-hm-reset]'); if (r) r.addEventListener('click', function () { sides.forEach(function (s) { s._reset(); }); });
  }

  function init() {
    initVersions(); initPicker();
    all('[data-hm-board="ladder"]').forEach(initLadder);
    all('[data-hm-board="timer"]').forEach(initTimer);
    all('[data-hm-board="tally"]').forEach(initTally);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
